import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import type { SxProps, Theme } from '@mui/material/styles';

export type ProgressOverlayPosition = 'fixed' | 'absolute' | 'relative' | 'static';

export interface ProgressOverlayProps extends Omit<CircularProgressProps, 'sx' | 'className'> {
  /**
   * How the overlay is positioned. `fixed` (default) covers the viewport and sits
   * above modals; the other values scope it to the nearest positioned ancestor.
   */
  position?: ProgressOverlayPosition;
  /** Set to false to drop the translucent white scrim and show only the spinner. */
  scrim?: boolean;
  /** Extra class names for the overlay wrapper (not the spinner). */
  className?: string;
  sx?: SxProps<Theme>;
}

export const ProgressOverlay = ({
  position = 'fixed',
  scrim = true,
  className,
  sx,
  ...progressProps
}: ProgressOverlayProps) => {
  return (
    <Box
      className={className ? `progress-wrapper ${className}` : 'progress-wrapper'}
      sx={{
        position,
        zIndex: position === 'fixed' ? 3000 : 999,
        backgroundColor: scrim ? 'rgba(255, 255, 255, 0.4)' : 'transparent',
        ...sx,
      }}
    >
      <CircularProgress color='primary' size={50} {...progressProps} />
    </Box>
  );
};
